import { useBreadcrumb } from "features/breadcrumbs";
import ListaEquipamentos from "./components";
import Container from "components/Container";

function EquipamentosListaPage() {
  useBreadcrumb([
    { name: "Administração" },
    { name: "Controle de Patrimônios", url: "/administracao/patrimonio" },
  ]);
  return (
    <Container>
      <ListaEquipamentos />
    </Container>
  );
}

export default EquipamentosListaPage;
